import { render, staticRenderFns } from "./add-currency-form.vue?vue&type=template&id=7e4124cc&"
import script from "./add-currency-form.vue?vue&type=script&lang=ts&"
export * from "./add-currency-form.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports